import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding #23: Slackbots and OAuth",
  "description": "",
  "published": "2016-09-26T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-23-slackbots-oauth/swizec/7065"],
  "categories": "JavaScript, Livecoding, slack, slackbot, Technical",
  "hero": "./img/jdqcwa6.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding ?. Always under 500 words and with pictures. You can follow my channel, `}<a parentName="em" {...{
          "href": "https://livecoding.tv/swizec"
        }}>{`here`}</a>{`. New streams almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{`. There’s live chat, come say hai ?`}</em></p>
    <p>{`This is embarrassing. That `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-22-a-door-answering-slackbot/swizec/7038"
      }}>{`Slack bot that opens doors`}</a>{` from last week… it still doesn’t work. I thought we almost had it. I thought I’d identified the hard part. I thought it was just a matter of sitting down and smashing it out.`}</p>
    <p>{`I was blindsided by OAuth and the exploding complexity that always comes in tutorials and API docs! They show you how simple their API is. How absolutely beautiful to use!`}</p>
    <p>{`One line of code, two clicks of set up, and you’re sending messages to Slack like a champ. Two clicks, a bit of code, and you’re a bot! You can listen to people’s conversations.`}</p>
    <p>{`Champ! King of the world. ??`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "513px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "13.452914798206278%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'53\\'%20viewBox=\\'0%200%20400%2053\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2011c-2%201-2%204%200%205%202%200%201%204-2%206-2%203-4%202-3-1s-2-6-4-5-4%2014-2%2017c1%202%2020%203%2023%201%202-1%203-20%200-22-1-2-6-3-8-1h-4m28%203l-1%203v-1c0-2%200-2-2-2s-3%202-1%204v2h14c1%201%206%201%207-1h1c1%202%207%202%209%201h2c2%202%205%200%205-3l1-2v2l1%203h2v-7h-3c-1%201-4%202-9%201l-2-1-1-2-1%204-1%204-1-2c1-3-1-4-2-2-1%201-1%200-1-1%200-3-2-4-2-1%200%201-1%202-2%201-2%200-3%200-4%202h-1c0-2-1-2-2-2-2%201-3%200-3-1-1-3-3-2-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/878c35fe4bff4860f323ba4bd08680c0/ca0a1/jdqcwa6.webp 223w", "/static/878c35fe4bff4860f323ba4bd08680c0/75680/jdqcwa6.webp 445w", "/static/878c35fe4bff4860f323ba4bd08680c0/3be34/jdqcwa6.webp 513w"],
              "sizes": "(max-width: 513px) 100vw, 513px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/878c35fe4bff4860f323ba4bd08680c0/e92b6/jdqcwa6.png 223w", "/static/878c35fe4bff4860f323ba4bd08680c0/e66bf/jdqcwa6.png 445w", "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png 513w"],
              "sizes": "(max-width: 513px) 100vw, 513px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png",
              "alt": "jdqcwa6",
              "title": "jdqcwa6",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Oh, you want to `}<em parentName="p">{`actually`}</em>{` receive the promised POST requests from those message buttons? Boy, do I have a trip for you!`}</p>
    <p>{`First, you have to set up a Slack app. Not an ad-hoc custom integration like you’ve had until now. Oh no, you need a `}<em parentName="p">{`real`}</em>{` app. It takes a few clicks on this screen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "552px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/08c0b/X3cgSTS.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "102.69058295964125%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'412\\'%20viewBox=\\'0%200%20400%20412\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M90%2011c-3%207-3%208-2%208l2-1c0-2%206%200%208%203h3l2-2c2%200%204-4%202-6-2-3-6-2-7%202v3l-2-5c-2-6-4-6-6-2M21%20152c0%204%200%204%203%204l4-2h2c0%202%205%203%205%201l-1-1h-3l2-1%202-1%201%201c1%204%203%204%204%201v-2l1%202c1%202%205%203%205%201l-1-1h-1c-1-1%200-1%201-1%202%200%203-1%201-3h-7c-1%202-1%202-2%200h-6c-1%201-2%200-3-1l-4-2c-3%200-3%200-3%205m10%2020v19l10%201h9v-20l-10-1-9%201m273%20197c-2%201-1%2024%201%2024%203%202%2073%201%2074%200l1-13v-11l-38-1-38%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4f3fe0523ca6ca5fee49a5f3df02abeb/ca0a1/X3cgSTS.webp 223w", "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/75680/X3cgSTS.webp 445w", "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/dd35b/X3cgSTS.webp 552w"],
              "sizes": "(max-width: 552px) 100vw, 552px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4f3fe0523ca6ca5fee49a5f3df02abeb/e92b6/X3cgSTS.png 223w", "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/e66bf/X3cgSTS.png 445w", "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/08c0b/X3cgSTS.png 552w"],
              "sizes": "(max-width: 552px) 100vw, 552px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/4f3fe0523ca6ca5fee49a5f3df02abeb/08c0b/X3cgSTS.png",
              "alt": "X3cgSTS",
              "title": "X3cgSTS",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Then it’s going to say that this app is part of your team, `}<em parentName="p">{`but it’s not`}</em>{`. You have to set up OAuth, have a server that can do OAuth, and then authorize your team with this new app. You need to add an `}<inlineCode parentName="p">{`https`}</inlineCode>{` URL on this screen:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "711px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3ac3d78af8484714385dab23f0544a56/a8e5b/pr9miPw.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "59.19282511210761%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'237\\'%20viewBox=\\'0%200%20400%20237\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2015c-4%204-1%209%204%209%203%200%206-2%206-5%200-5-7-8-10-4m66%201l-2%201c-3-3-8%200-7%204s7%205%207%202l-1-1h-3c-1-1-1-1%201-1l4-2c1-1%201-1%201%201%200%203%202%205%204%204v-1l-1-2c0-2%201-3%202-3l1%202c0%203%202%205%204%204v-9h-7c0-2-1-1-3%201M11%20216v10h68v-19l-34-1H11v10\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3ac3d78af8484714385dab23f0544a56/ca0a1/pr9miPw.webp 223w", "/static/3ac3d78af8484714385dab23f0544a56/75680/pr9miPw.webp 445w", "/static/3ac3d78af8484714385dab23f0544a56/68932/pr9miPw.webp 711w"],
              "sizes": "(max-width: 711px) 100vw, 711px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/3ac3d78af8484714385dab23f0544a56/e92b6/pr9miPw.png 223w", "/static/3ac3d78af8484714385dab23f0544a56/e66bf/pr9miPw.png 445w", "/static/3ac3d78af8484714385dab23f0544a56/a8e5b/pr9miPw.png 711w"],
              "sizes": "(max-width: 711px) 100vw, 711px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/3ac3d78af8484714385dab23f0544a56/a8e5b/pr9miPw.png",
              "alt": "pr9miPw",
              "title": "pr9miPw",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`On the server side, you’re in for a world of doubya-tee-eff, mate. If you’re on express.js, then you can use `}<a parentName="p" {...{
        "href": "https://github.com/simov/grant"
      }}>{`Grant`}</a>{` to set up Slack OAuth somewhat painlessly. `}<em parentName="p">{`In theory`}</em>{`, this is all it takes:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// app.js
var session = require("express-session"),
  Grant = require("grant-express");

var grant = new Grant({
  server: {
    protocol: "https",
    host: "swizec.ngrok.io",
    callback: "/callback",
    transport: "session",
    state: true,
  },
  slack: {
    key: "14110144963.81022664631",
    secret: "24df277cd8e3d24e32087885c6ee7c80",
    scope: [
      "chat:write:bot",
      "chat:write:user",
      "channels:read",
      "commands",
      "incoming-webhook",
    ],
    //callback: '/connect/slack/callback'
  },
});

// ...

app.use(session({ secret: "grant", resave: false, saveUninitialized: true }));

app.use(grant);
`}</code></pre>
    <p>{`This uses express’s in-memory session storage, which means that as soon as you restart the server, sessions will be forgotten. The good news is that you don’t have to hold on to them; you just need them long enough to do the OAuth dance.`}</p>
    <p>{`Oh ,and that `}<inlineCode parentName="p">{`callback`}</inlineCode>{` parameter Grant asks for? That is `}<em parentName="p">{`not`}</em>{` the same as the `}<inlineCode parentName="p">{`Redirect URL`}</inlineCode>{` that Slack asks for. Set them to the same value, and you’re going for an endless redirect ride. Learned that the hard way. ☺️`}</p>
    <p>{`Go to `}<inlineCode parentName="p">{`<server>/connect/slack`}</inlineCode>{` and do the OAuth dance for your team. If all goes well, Slack rewards you with this message:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "684px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/57f613ff33005ede0704376e92ef2ad2/2c288/tKSzdCf.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "8.071748878923767%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'32\\'%20viewBox=\\'0%200%20400%2032\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M12%208c-3%204-3%206-2%2010%201%202%202%204%201%205v3h8c9%200%2011-1%207-3-3-1-3-3%200-2%202%200%202%200%201-1l-1-1c2%200%204-11%202-13h-6l-1%201c-6-2-7-2-9%201m33%200c0%201-2%202-5%201-5%200-5%200-5%202s1%203%202%203l1-2v-2l1%202c1%202%205%202%206%200h1c0%202%201%202%205%202l5-1h4c1-1%201-1-1-1v-2c2-1%202-1-2-1-8%200-10%200-9-1h-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/57f613ff33005ede0704376e92ef2ad2/ca0a1/tKSzdCf.webp 223w", "/static/57f613ff33005ede0704376e92ef2ad2/75680/tKSzdCf.webp 445w", "/static/57f613ff33005ede0704376e92ef2ad2/e213b/tKSzdCf.webp 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/57f613ff33005ede0704376e92ef2ad2/e92b6/tKSzdCf.png 223w", "/static/57f613ff33005ede0704376e92ef2ad2/e66bf/tKSzdCf.png 445w", "/static/57f613ff33005ede0704376e92ef2ad2/2c288/tKSzdCf.png 684w"],
              "sizes": "(max-width: 684px) 100vw, 684px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/57f613ff33005ede0704376e92ef2ad2/2c288/tKSzdCf.png",
              "alt": "tKSzdCf",
              "title": "tKSzdCf",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`If you go to Slack’s app management panel, you should see something like this:`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/38985d75f72ccb21044c2bcba02f206b/620ae/fXYJiPV.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "71.30044843049328%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'285\\'%20viewBox=\\'0%200%20400%20285\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M183%2017l1%204%201-1%202-1%202-1h7l-1-1h-3l2-1c2%200%203%201%203%202l2%201%201-2%201-3%201%203%201%202v-5c0-2-5-3-6-1h-8l-4-1c-2%200-2%200-2%205M33%2021c-16%205-20%207-20%208l2%202v3l1%202a739%20739%200%200112%2041l14-4%2014-4v4c0%204%200%204%205%205%205%202%205%201%207-6l3-8c2-1%202-2%201-6-1-3-1-6%201-19l3-15-5-1c-6%200-7%201-7%205s-2%201-4-6-3-8-4-8l-23%207M6%2030c-2%203%2014%2050%2016%2050l-7-26-9-24m95%20230l1%203%201-2h1c1%202%207%202%207%200h1c0%203%202%202%202%200s0-2%201%200l1%203%201-3%201-2v2c0%201%200%202%201%201h11c2%202%204%201%204-1%200-3-3-5-4-2h-3l-4-1h-12c-1-2-4%200-4%202s0%202-1%201v-3c0-2%200-2-2-2-3%200-3%200-3%204m217%204l1%207h44v-13l-23-1h-22v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/38985d75f72ccb21044c2bcba02f206b/ca0a1/fXYJiPV.webp 223w", "/static/38985d75f72ccb21044c2bcba02f206b/75680/fXYJiPV.webp 445w", "/static/38985d75f72ccb21044c2bcba02f206b/8d1ba/fXYJiPV.webp 890w", "/static/38985d75f72ccb21044c2bcba02f206b/88fcb/fXYJiPV.webp 1043w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/38985d75f72ccb21044c2bcba02f206b/e92b6/fXYJiPV.png 223w", "/static/38985d75f72ccb21044c2bcba02f206b/e66bf/fXYJiPV.png 445w", "/static/38985d75f72ccb21044c2bcba02f206b/4ef49/fXYJiPV.png 890w", "/static/38985d75f72ccb21044c2bcba02f206b/620ae/fXYJiPV.png 1043w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/38985d75f72ccb21044c2bcba02f206b/4ef49/fXYJiPV.png",
              "alt": "fXYJiPV",
              "title": "fXYJiPV",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`/partyhard`}</p>
    <p>{`Your app is officially set up for your team. The slash command you created while debugging and trying to figure out what’s up works. You say `}<inlineCode parentName="p">{`/hai`}</inlineCode>{` and it says `}<inlineCode parentName="p">{`pong`}</inlineCode>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/0f10ab003209cfd93ec4b82e29b8b952/IIb41yd.gif",
        "alt": null
      }}></img></p>
    <p>{`But when you click a button on a message that you sent, you still get the error. No POST request hits your server. It’s an immediate error. It doesn’t even `}<em parentName="p">{`try`}</em>{` to do the thing.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "513px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "13.452914798206278%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'53\\'%20viewBox=\\'0%200%20400%2053\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2011c-2%201-2%204%200%205%202%200%201%204-2%206-2%203-4%202-3-1s-2-6-4-5-4%2014-2%2017c1%202%2020%203%2023%201%202-1%203-20%200-22-1-2-6-3-8-1h-4m28%203l-1%203v-1c0-2%200-2-2-2s-3%202-1%204v2h14c1%201%206%201%207-1h1c1%202%207%202%209%201h2c2%202%205%200%205-3l1-2v2l1%203h2v-7h-3c-1%201-4%202-9%201l-2-1-1-2-1%204-1%204-1-2c1-3-1-4-2-2-1%201-1%200-1-1%200-3-2-4-2-1%200%201-1%202-2%201-2%200-3%200-4%202h-1c0-2-1-2-2-2-2%201-3%200-3-1-1-3-3-2-3%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/878c35fe4bff4860f323ba4bd08680c0/ca0a1/jdqcwa6.webp 223w", "/static/878c35fe4bff4860f323ba4bd08680c0/75680/jdqcwa6.webp 445w", "/static/878c35fe4bff4860f323ba4bd08680c0/3be34/jdqcwa6.webp 513w"],
              "sizes": "(max-width: 513px) 100vw, 513px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/878c35fe4bff4860f323ba4bd08680c0/e92b6/jdqcwa6.png 223w", "/static/878c35fe4bff4860f323ba4bd08680c0/e66bf/jdqcwa6.png 445w", "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png 513w"],
              "sizes": "(max-width: 513px) 100vw, 513px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/878c35fe4bff4860f323ba4bd08680c0/267f6/jdqcwa6.png",
              "alt": "jdqcwa6",
              "title": "jdqcwa6",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`It’s an identity issue, I think. Based on `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-22-a-door-answering-slackbot/swizec/7038"
      }}>{`last week’s livecoding`}</a>{`, we’re sending Slack messages based on an ad-hoc integration API key. But we’re a real app, so we should send them as the app.`}</p>
    <p>{`Slack’s documentation doesn’t say how to do that. It talks only about API keys, but apps don’t get API keys. Or I don’t understand the docs. Or I’m blind.`}</p>
    <p>{`I should send them an email. ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      